module.exports = __webpack_public_path__ + "img/流程-6.a6bfba73.jpg";